export const convertWidgetData = () => ({
  calculatorSettings: {
    maxPrice: '0',
    options: [
      {
        title: 'Устройство',
        slug: 'deviceTypes',
        list: [],
        activeOption: null,
      },
      {
        title: 'Бренд',
        slug: 'brands',
        list: [],
        activeOption: null,
      },
      {
        title: 'Модель',
        slug: 'models',
        list: [],
        activeOption: null,
      },
      {
        title: 'Память',
        slug: 'capacity',
        list: [],
        activeOption: null,
      },
    ],
  },
});
